"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachFileContainer = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const server_1 = require("../../../../server");
const account_1 = require("../../../base/account");
const AttachFileAnswer_1 = require("./AttachFileAnswer");
const AttachFileContainer = ({ member_id, test_id, item, isPreview, submitted, }) => {
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const [answerList, setAnswerList] = react_1.default.useState([]);
    const [attachFileList, setAttachFileList] = (0, react_1.useState)([]);
    const [submittedFileList, setSubmittedFileList] = (0, react_1.useState)([]);
    const { data: submittedAnswers, refetch: refetchAnswerData } = (0, server_1.useAnswerList)({
        test_id,
        from: member_id || '',
        order: 'value',
    });
    const questionFileList = (0, react_1.useMemo)(() => item?.attachments || [], [item?.attachments]);
    (0, react_1.useEffect)(() => {
        if (test_id && member_id !== '') {
            refetchAnswerData();
        }
        else {
            setAnswerList([]);
        }
    }, [isPreview, test_id, member_id]);
    (0, react_1.useEffect)(() => {
        if (member_id === '') {
            setAnswerList([]);
            return;
        }
        if (submittedAnswers) {
            setAnswerList(submittedAnswers.items);
        }
        else {
            setAnswerList([]);
        }
    }, [member_id, submittedAnswers]);
    (0, react_1.useEffect)(() => {
        if (!answerList || answerList.length === 0)
            return;
        const valuesArray = answerList.map(item => item?.value);
        setSubmittedFileList(valuesArray);
    }, [answerList]);
    if (isTeacher && member_id === '') {
        return (react_1.default.createElement("div", { className: "feedback-file" },
            react_1.default.createElement(AttachFileAnswer_1.AttachFileAnswer, { isTeacher: isTeacher, showRegist: false, isRegist: false, attachFileList: questionFileList })));
    }
    else {
        if (submitted) {
            return (react_1.default.createElement("div", { className: "feedback-file" },
                react_1.default.createElement(AttachFileAnswer_1.AttachFileAnswer, { isTeacher: isTeacher, showRegist: false, isRegist: false, attachFileList: submittedFileList })));
        }
        if (!isPreview) {
            return (react_1.default.createElement("div", { className: "submit-false" },
                react_1.default.createElement("p", null, "\uC81C\uCD9C\uB41C \uD30C\uC77C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.")));
        }
        return (react_1.default.createElement("div", { className: "feedback-file" },
            react_1.default.createElement(AttachFileAnswer_1.AttachFileAnswer, { isTeacher: isTeacher, showRegist: false, isRegist: false, attachFileList: attachFileList })));
    }
};
exports.AttachFileContainer = AttachFileContainer;
